import { render, staticRenderFns } from "./producIdtList.vue?vue&type=template&id=4cd6c5a0&scoped=true&"
import script from "./producIdtList.vue?vue&type=script&lang=js&"
export * from "./producIdtList.vue?vue&type=script&lang=js&"
import style0 from "./producIdtList.vue?vue&type=style&index=0&id=4cd6c5a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd6c5a0",
  null
  
)

export default component.exports